/** CMS title "Home" is system content (case-insensitive). */
export function isHomeContent(title?: string | null): boolean {
  return typeof title === 'string' && /^home$/i.test(title.trim());
}
